import React from 'react';
import {
  TableCell,
  TableRow
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { TextFormattedNumber } from 'components';
import { convertUTCDateToLocalDate } from 'helpers/date';
import { giftCardStatus, giftCardHistoryActions } from 'helpers/giftCards';


const GiftHistoryTableRow = ({giftHistoryData, headTableCells, labelId, selectedGiftCode}) => {
  const {
    history_id,
    created_at,
    action,
    balance,
    amount,
    status,
    detail,
    comment,
    extra_content = '{}'
  } = giftHistoryData;

  const columns = headTableCells.reduce((acc, column) => {
    acc[column.label] = column;

    return acc;
  }, {});

  const createdAtdate = convertUTCDateToLocalDate(created_at);
  const extraContentObject = JSON.parse(extra_content);
  const isCreatedByCustomer = giftCardHistoryActions[action] === 'Created' && !!selectedGiftCode?.order_increment_id;
  const isRedeemed = giftCardHistoryActions[action] === 'Redeemed';

  return (
    <TableRow>
      {columns['Id']?.display &&
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {history_id}
      </TableCell>
      }
      {columns['Action']?.display &&
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {giftCardHistoryActions[action]}
      </TableCell>
      }
      {columns['Balance']?.display &&
      <TableCell component="th" id={labelId} scope="row" padding="none">
        <TextFormattedNumber
          value={balance}
          prefix="$"
        />
      </TableCell>
      }
      {columns['Amount Change']?.display &&
      <TableCell component="th" id={labelId} scope="row" padding="none">
        <TextFormattedNumber
          value={amount}
          prefix="$"
        />
      </TableCell>
      }
      {columns['Status']?.display &&
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {giftCardStatus[status]}
      </TableCell>
      }
      {columns['Detail']?.display &&
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {isCreatedByCustomer && (
          <Link className="text-primary underline" to={{pathname: '/orders/list', state: {orderId: selectedGiftCode?.order_increment_id}}}>
            {detail}
          </Link>
        )}
        {isRedeemed && extraContentObject?.customer_id && (
          <Link className="text-primary underline" to={{pathname: `/customers/${extraContentObject.customer_id}/details`}}>
            {detail}
          </Link>
        )}
        {!isCreatedByCustomer && !isRedeemed && detail}
      </TableCell>
      }
      {columns['Date and Time']?.display &&
      <TableCell component="th" id={labelId} scope="row" padding="none">
        <div className="my-2">
          <div>{format(createdAtdate, 'MM/dd/yyyy')}</div>
          <div>{format(createdAtdate, 'hh:mm:ss aa')}</div>
        </div>
      </TableCell>
      }
      {columns['Comment']?.display &&
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {comment}
      </TableCell>
      }
    </TableRow>
  );
};

export default GiftHistoryTableRow;
